module.exports = __webpack_public_path__ + "static/media/users.4076ea6b.jpg";